import { LogsComponent } from './logs.component';
import { LogComponent } from './log/log.component';
import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BBSFControlsModule } from 'bbsf-controls';
import { BlockUIModule } from 'ng-block-ui';
import { AuthModule } from '../core/auth.module';
import { LogsRoutingModule } from './logs-routing.module';
import { SubheaderModule } from '../_layout/components/subheader/subheader.module';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bbsf-utilities';
import { LogsService } from '../shared/Services/LogsService';


@NgModule({
  declarations: [LogComponent, LogsComponent],
  imports: [
    LogsRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    SubheaderModule,
    InlineSVGModule,
    EmptyDataModule
  ],
  providers: [
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    LogsService
  ]
})

export class LogsModule { }
